var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg094Thermometer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "current"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M241,152c-11.046,0-20,8.954-20,20v185.352c-11.956,6.916-20,19.842-20,34.648c0,22.091,17.909,40,40,40s40-17.909,40-40 c0-14.805-8.044-27.732-20-34.648V172C261,160.954,252.046,152,241,152z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371,192c11.046,0,20-8.954,20-20s-8.954-20-20-20h-40v-31h40c11.046,0,20-8.954,20-20s-8.954-20-20-20h-40.447 C326.023,35.583,287.589,0,241,0c-49.626,0-90,40.374-90,90v222.626c-19.408,21.929-30,49.796-30,79.374 c0,66.168,53.832,120,120,120s120-53.832,120-120c0-25.134-7.695-49.206-22.255-69.615c-6.413-8.991-18.901-11.079-27.896-4.666 c-8.992,6.414-11.081,18.904-4.666,27.896C315.876,359.204,321,375.243,321,392c0,44.112-35.888,80-80,80s-80-35.888-80-80 c0-21.661,8.524-41.948,24.002-57.123c3.836-3.762,5.998-8.908,5.998-14.281V90c0-27.57,22.43-50,50-50s50,22.43,50,50v152 c0,11.046,8.954,20,20,20h60c11.046,0,20-8.954,20-20s-8.954-20-20-20h-40v-30H371z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg094Thermometer);
export default __webpack_public_path__ + "static/media/094-thermometer.5e84efc9e4135c9ba69bbf74c4e40557.svg";
export { ForwardRef as ReactComponent };